const addInfo = {
  title: 'AdvanceRoute',
  icon: 'route'
}
const advanceRouteRouter = {
  path: '/advance-route',
  meta: {
    title: 'AdvanceRoute',
    icon: 'route',
      permission: ['advanced_route']
  },
  children: [
      {
          path: 'advance-route',
          component: () => import('@/views/route/Route/route-management.vue'),
          name: 'AdvanceRoute',
          meta: { title: 'AdvanceRoute', parent: addInfo, permission: ['advanced_route_enable'] }
      }
  ]
}

export default advanceRouteRouter